import { useEffect } from 'react'
import { usePostHog } from 'posthog-js/react'
import { useUserStore } from 'stores/users'
import { PostHogPersonProperty } from './posthog/events'

const buildPersonProperties = (user, permissions: string[]) => {
  const properties = {
    [PostHogPersonProperty.EMAIL]: user?.email || undefined,
    [PostHogPersonProperty.FIRST_NAME]: user?.first_name || undefined,
    [PostHogPersonProperty.LAST_NAME]: user?.last_name || undefined,
    [PostHogPersonProperty.DATA_SOURCE]: user?.data_source || undefined,
    [PostHogPersonProperty.DATA_SOURCE_HASHID]: user?.data_source_hashid || undefined,
    [PostHogPersonProperty.PERMISSIONS]: permissions?.length ? permissions : undefined,
    [PostHogPersonProperty.PERMISSIONS_COUNT]: permissions?.length ? permissions.length : undefined,
  }

  return Object.fromEntries(Object.entries(properties).filter(([, value]) => value !== undefined))
}

const usePostHogIdentify = () => {
  const posthog = usePostHog()
  const isLogged = useUserStore((state) => state.isLogged)
  const userId = useUserStore((state) => state.id)
  const user = useUserStore((state) => state.User)
  const permissions = useUserStore((state) => state.User.high_level_permissions)

  useEffect(() => {
    if (!posthog) {
      return
    }

    if (isLogged && userId) {
      posthog.identify(userId, buildPersonProperties(user, permissions))
      return
    }

    posthog.reset()
  }, [posthog, isLogged, userId, user, permissions])
}

export default usePostHogIdentify
